import { useQuery } from '@tanstack/react-query';

// AIDEV-NOTE: Tipos locais para Visita — devem ser migrados para @azoupvendas/shared quando estabilizados
export interface VisitaFormulario {
  observacoes?: string;
  objetivo?: string;
  resultado?: string;
  proxima_acao?: string;
  tags?: string[];
  fotos?: string[];
  campos_extras?: Record<string, unknown>;
}

export interface Visita {
  id: string;
  cliente_id: string;
  vendedor_id: string;
  checkin_at: string;
  checkout_at?: string;
  formulario?: VisitaFormulario;
  status: 'em_andamento' | 'concluida' | 'cancelada';
  duracao_minutos?: number;
  cliente_nome?: string;
  vendedor_nome?: string;
  tipo_visita?: string;
  checkin_lat?: number;
  checkin_lng?: number;
  checkout_lat?: number;
  checkout_lng?: number;
}

async function fetchVisitas(params: Record<string, string>): Promise<Visita[]> {
  const qs = new URLSearchParams(params).toString();
  const res = await fetch(`/api/v1/visitas?${qs}`, { credentials: 'include' });
  if (!res.ok) throw new Error('Falha ao buscar visitas');
  const { data } = await res.json();
  return data;
}

export function useVisitas(params: Record<string, string> = {}) {
  return useQuery({
    queryKey: ['visitas', params],
    queryFn: () => fetchVisitas(params),
    staleTime: 5 * 60 * 1000
  });
}

export function useVisitasCliente(clienteId: string) {
  return useVisitas({ cliente_id: clienteId });
}
